export const useQueryHeaders = <T extends Record<string, unknown>>(options: T = {} as T): T => {
    return {
        ...options,
    };
};

export default useQueryHeaders;
